import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import template from './end-of-game.html';

const mapStateToThis = ({ config }) => {
  const { endOfGameUrl } = config;

  return {
    endOfGameUrl,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$state', '$stateParams')
class EndOfGameWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.isEmpty = false;
    this.isLoading = false;
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class EndOfGameWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = EndOfGameWidgetController;
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/end-of-game/end-of-game-component.js